import type { JSX } from "react";
import type { SessionState } from "@shared/types";

/**
 * Session lifecycle indicator (#228): active | idle | deleted. Color scarcity —
 * only active (success) and deleted (error) carry semantic colour; idle stays
 * neutral. Sentence-case Chinese labels, tokens-only styling via cc-tone-*.
 */
const META: Record<SessionState, { label: string; tone: string }> = {
  active: { label: "活跃", tone: "ok" },
  idle: { label: "空闲", tone: "mute" },
  deleted: { label: "已删除", tone: "err" }
};

export function SessionStateBadge({ state }: { state: SessionState }): JSX.Element {
  const m = META[state];
  return <span className={`cc-tag cc-tone-${m.tone}`}>{m.label}</span>;
}
